export * from './forgot-pass.component'